import _ from 'lodash';

import { createSelector } from 'reselect';

import Config from './config/config';

const Selectors = {};

const getState = state => _.get(state, Config.stateKey);

Selectors.isModuleVisible = createSelector(
  [getState, (state, id) => id],
  (state, id) => !!_.get(state, [id, 'isVisible'])
);

export default Selectors;
